export const REGEX = {
  DOT_OR_COMMA: /[.,]+/,
  FULL_NUMBER: /[^0-9.,\-+]/g,
  STRING: {
    BASE64_DESCRIPTION: /data:(.*?)base64,/,
    SPACE: /\s/g,
  },
  FIND_CLASS_NAME: (className: string) => new RegExp("(^| )" + className + "( |$)", "gi"),
} as const;
